import { useAppSelector } from "../../../store/hooks";
import taskStyles from "../../../styles/ganttChart/tasks.module.css";
import { Fragment } from "react";
import ganttChartStyles from "../../../styles/ganttChart/ganttChart.module.css";

const DragAndDropTask = ({}: {}) => {
  const { xPosition, yPosition, taskBeingDragged, taskBoxConfigurtion } =
    useAppSelector((state) => state.dragAndDropSlice);

  return (
    <>
      {taskBeingDragged && taskBoxConfigurtion && (
        <foreignObject
          x={xPosition}
          y={yPosition}
          width={taskBoxConfigurtion.width}
          height={taskBoxConfigurtion.height}
        >
          <div
            className={taskStyles.verticalWorkTask}
            style={{
              zIndex: 1000,
              borderLeft: `${taskBoxConfigurtion.border}`,
              borderBottom: `${taskBoxConfigurtion.border}`,
              backgroundColor: `${taskBoxConfigurtion.backgroundColor}`,
            }}
          >
            {/* TODO: should this be viasible on dragged as well? */}
            {/* {crossTeamAssignment && (
          <div className={taskStyles.crossTeamBadgeContainer}>
            <p>{crossTeamAssignment}</p>
          </div>
        )} */}
            {taskBeingDragged.task.client &&
            taskBeingDragged.task.client.description ? (
              <p className={taskStyles.verticalTaskText}>
                <b>{taskBeingDragged.task.client.description}</b>
              </p>
            ) : (
              <p className={taskStyles.verticalTaskText}>
                {taskBeingDragged.task.description}
              </p>
            )}

            {taskBoxConfigurtion.allowedLines > 1 &&
              taskBeingDragged.task.subTasks && (
                <ul className={taskStyles.taskList}>
                  {taskBeingDragged.task.subTasks.map((task, index) => (
                    <Fragment key={index}>
                      {taskBoxConfigurtion.allowedLines > index + 1 && (
                        <li className={taskStyles.verticalTaskText}>
                          <div className={ganttChartStyles.bulletPoint}></div>
                          {task.description}
                        </li>
                      )}
                    </Fragment>
                  ))}
                </ul>
              )}
          </div>
        </foreignObject>
      )}
    </>
  );
};

export default DragAndDropTask;
